<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 248 262">
  <g id="colorchange">
    <path class="cls-1" fill="#00002f" fill-opacity="0.6" d="M0,262H208.09L248,222.09V0H39.91L0,39.91Z"/>
  </g>
</svg>
</template>